import { useState, useEffect } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import get from 'lodash/get';
import {
  API,
  Notes,
} from 'vibeguide';
import './OrderNotes.scss';

function OrderNotes({
  className = '',
  style = {},
  orderId,
  notes: propNotes = [],
  canAddNote = false,
}) {
  const [notes, setNotes] = useState(propNotes || []);

  /**
   * Create a Note
   */
  const onCreateNote = async (note, onSuccess, onError) => {
    try {
      const response = await API.Order.addNote({
        _id: orderId,
        note,
      });

      const success = get(response, '[0].type') === 'ORDER.ACTIVITY_ADDED';

      if (success) {
        const note = {
          _id: response[0].data.noteId,
          date: moment().toISOString(),
          activityType: response[0].data.activityType,
          userFName: response[0].data.userFName,
          userLName: response[0].data.userLName,
          note: response[0].data.note,
        };

        setNotes([...notes, note]);
        onSuccess();
      } else {
        onError('Error Creating Note');
      }
    } catch (err) {
      // error adding the note
      onError(err.message);
    }
  };

  /**
   * When notes change from parent component, update local state
   */
  useEffect(() => {
    setNotes(propNotes || []);
  }, [propNotes]);

  return (
    <div
      className={classNames('OrderNotes', className)}
      style={style}
    >
      <Notes
        notes={notes?.map((item) => {
          return {
            _id: item._id,
            type: item.activityType,
            userId: item.userId,
            username: `${item.userFName} ${item.userLName}`,
            date: item.date,
            avatarUrl: item.userImageUrl,
            note: item.note,
          };
        })}
        allowCreate={canAddNote}
        numVisibleMessages={5}
        onCreate={onCreateNote}
      />
    </div>
  );
}

export default OrderNotes;
